<div class="flex-row" ssgClickOutside (clickOutside)="close()">
  <div class="calendar-field flex-100" [ngClass]="{'calendar-field-right': justify === 'right'}">
    <input ngbDatepicker [dayTemplate]="tpl" navigation="arrows" #dp="ngbDatepicker" class="dp-input" [ngClass]="{'red': invalidDate || hasValidationError}" firstDayOfWeek="0" placeholder="{{ 'COMMON.DATE_FORMAT' | translate }}">
  </div>
  <ukg-button icon-only slot="end" (click)="toggle()" [disabled]="dp.disabled" type="button" class="open-btn">
    <ukg-icon slot="parent-icon"  name="calendar"></ukg-icon>
  </ukg-button>
</div>
<ukg-label [hidden]="!invalidDate" class="text-danger">{{ errorMessage | translate: {minDate : minDate | date:'longDate'} }}</ukg-label>
<ukg-label [hidden]="!warningMessage" class="text-warning">{{ warningMessage | translate }}</ukg-label>

<ng-template #tpl let-date="date" let-currentMonth="currentMonth" let-selected="selected" let-disabled="disabled">
  <span class="day" [class.selected]="selected" [class.text-muted]="date.month !== currentMonth" [class.disabled]="disabled" [class.whitelisted]="isWhitelisted(date)" >
    {{ date.day }}
  </span>
</ng-template>